export enum NumberOfColumns {
    Two = "2",
    Three = "3",
    Four = "4"
}
